import { differenceInYears } from "date-fns";
import { getRecords } from "../../../api/useRecords";
import { Notifications } from "../../../store/store.types";
import { AvailabilityPreferences } from "./types";
import { getRelateServicesFromConstants } from "../../../utils/getRelatedServicesFromConstants";

export const findAvailabilityFormValidations = (data: AvailabilityPreferences, notifications: Notifications) => {
    const firstServiceId = data.firstService?.id;
    const secondServiceId = data.secondService?.id;
    const preferredDays = data.preferredDays;
    const leadOrTreatment = data.leadOrTreatment;
    const ageFilter = data.age_groups?.id;
    const disorderFilter = data.disorder_specialization?.id;
    const firstServiceTechnician = data.firstServiceTechnician?.id;
    const secondServiceTechnician = data.secondServiceTechnician?.id;
    const isUserRequiredService = getRelateServicesFromConstants("psy");
    const clinicId = data.clinic_id;
    
    const callNotification = (message: string) => {
        notifications.setNotification({
            message,
            isOpen: true,
            severity: "error",
        });
    };
    if (!clinicId) {
        callNotification("Tem que escolher uma clínica");
        return;
    }

    if (leadOrTreatment === "treatment" && !data.treatment) {
        callNotification("Tem que escolher um tratamento");
        return;
    }

    if (preferredDays.length === 0) {
        callNotification("Tem que escolher pelo menos um dia da semana");
        return;
    }

    if (!firstServiceId && !secondServiceId) {
        callNotification("Tem que escolher um serviço");
        return;
    }

    if (firstServiceId && secondServiceId && firstServiceId === secondServiceId) {
        callNotification("Não pode escolher o mesmo serviço para as duas sessões");
        return;
    }



    if (firstServiceId && isUserRequiredService.includes(firstServiceId)) {
        if (!firstServiceTechnician && !(ageFilter && disorderFilter)) {
            callNotification(
                "Tem que escolher um técnico ou definir os filtros de idade e perturbação para este serviço"
            );
            return;
        }
    }

    if (secondServiceId && isUserRequiredService.includes(secondServiceId)) {
        if (!secondServiceTechnician && !(ageFilter && disorderFilter)) {
            callNotification(
                "Tem que escolher um técnico ou definir os filtros de idade e perturbação para este serviço"
            );
            return;
        }
    }
    return true;
};

export const titleIfFirstSession = async (preferences: AvailabilityPreferences) => {
    const treatmentId = preferences.treatment?.id;
    if (!treatmentId) return null;
    const treatmentSessions = await getRecords("sessions", "*.*", {
        extraOptions: {
            withRowCount: true,
            filter: {
                _and: [
                    {
                        treatment: {
                            _eq: treatmentId,
                        },
                        service: {
                            _neq: 39, // does not include EEG
                        },
                    },
                ],
            },
        },
    });

    if (treatmentSessions.metadata.filter_count === 0) {
        return "1st Session";
    }
    return null;
};

export const titleIfFirstEeg = (preferences: AvailabilityPreferences) => {
    if (preferences.firstService.id === 39 && preferences.lead) {
        // add title only for EEG if lead is selected
        const birthday = new Date(preferences.lead.birthday);
        const title = `EEG: ${preferences.lead.first_name} ${preferences.lead.last_name}, ${differenceInYears(
            new Date(),
            birthday
        )}y   `;
        return title;
    }
    return "";
};
